import BaseBlock from "parent/src/js/base/Controllers/Blocks/BaseBlock";

class WpImage extends BaseBlock {

	init() {
		const img = this.block.querySelector("img");
		if (img) {
			img.style.width = img.getAttribute("width") + "px";
			img.style.height = img.getAttribute("height") + "px";
		}
	}
}

export default WpImage;
